var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Info-Circle"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15678",
    transform: "translate(-20 -10)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(20 10)",
    fill: "#74d3e8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M40 27.188v12"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(38.5 20.813)"
  })))));
}
export default SvgInfoCircle;